import { useEffect, useMemo, useState } from "react";
import { useContractRead } from "wagmi";
import { _notEmpty } from "../utils";
import { ERROR_NFTIDS, ERROR_RWA_PENDING_REWARDS, ERROR_RWA_READ } from "../utils/config";

const useRWAPositionNFT = ({
    chainId,
    forwardingDepositContract,
    userAddress,
    refetch,
}) => {
    const [positionData, setPositionData] = useState(null);
    const [totalDepositedData, setTotalDepositedData] = useState(null);
    const [rewardsData, setRewardsData] = useState(null);

    const enabled = useMemo(() => {
        return  _notEmpty(chainId)
        && _notEmpty(forwardingDepositContract?.abi)
        && _notEmpty(forwardingDepositContract?.address)
    }, [chainId, forwardingDepositContract])

    const isEnabledAndHasUserAddress = useMemo(() => {
        return enabled && _notEmpty(userAddress);
    }, [enabled, userAddress]);

    useContractRead({
        chainId,
        address: forwardingDepositContract?.address,
        abi: forwardingDepositContract?.abi,
        functionName: 'getTotalInterestUser',
        args: [
            userAddress
        ],
        watch: true,
        enabled: isEnabledAndHasUserAddress,
        onError: (error) => {
            console.error(`${ERROR_RWA_PENDING_REWARDS}`, error);
            setRewardsData(null);
        },
        onSuccess: (response) => {
            setRewardsData(response)
        },
    });

    const rwaPositionData = useContractRead({
        chainId,
        address: forwardingDepositContract?.address,
        abi: forwardingDepositContract?.abi,
        functionName: 'balanceOf',
        args: [
            userAddress
        ],
        enabled: isEnabledAndHasUserAddress,
        // watch: true,
        onError: (error) => {
            console.error(
                ERROR_NFTIDS,
                error
            );
        },
        onSuccess: (response) => {
            setPositionData(response);
        },
    });

    const rwaTotalDepositedData = useContractRead({
        chainId,
        address: forwardingDepositContract?.address,
        abi: forwardingDepositContract?.abi,
        functionName: 'totalSupply',
        args: [],
        enabled,
        onError: (error) => {
            console.error(
                ERROR_RWA_READ,
                error
            );
        },
        onSuccess: (response) => {
            setTotalDepositedData(response);
        },
    });

    useEffect(() => {
        // Only clear user-specific data when userAddress changes
        setPositionData(null);
        setRewardsData(null);

        if (userAddress) {
            rwaPositionData.refetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userAddress, refetch]);

    // Separate effect for refetching totalDepositedData when refetch changes
    useEffect(() => {
        if (enabled) {
            rwaTotalDepositedData.refetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetch]);

    return {
        positionData,
        rewardsData,
        totalDepositedData,
        isFetching: rwaPositionData?.isFetching
            || totalDepositedData?.isFetching
    };
};

export default useRWAPositionNFT;
